import { alpha, styled } from "@mui/material/styles";

import { AssetUrl } from "@holibob-packages/vault";

import { MainColumnVariableMargin } from "../../../components/MainColumnWrapper";
import { useNextTranslation } from "../../../hooks";
import { ProductContentEntryV2 } from "../../types";
import { ProductGalleryV2 } from "../ProductGalleryV2";
import { ProductHighlights } from "../ProductHighlights";
import { ProductSectionTitle } from "../ProductSectionTitle";
import { ProductSectionWrapper, ProductSectionWrapperProps } from "./ProductSectionWrapper";

type ProductExperienceSectionProps = {
    imageList: AssetUrl[];
    highlights?: ProductContentEntryV2[];
} & Omit<ProductSectionWrapperProps, "children">;
export const ProductExperienceSection = ({ highlights, imageList, ...props }: ProductExperienceSectionProps) => {
    const [t] = useNextTranslation("product");

    return (
        <ProductSectionWrapper
            ContainerComponent={ProductExperienceSectionWrapper}
            {...props}
            data-testid="product-experience-section"
        >
            <ProductSectionTitle>{t("highlights.experience")}</ProductSectionTitle>
            <ProductGalleryV2
                data-testid="product-experience-gallery"
                imageList={shiftArrayByOne(imageList)}
                seeAllLabel={t("gallery.seeAllImages.label")}
                height={400}
                maxWidthOnDesktop={888}
            />
            {highlights && <ProductHighlights content={highlights} />}
        </ProductSectionWrapper>
    );
};

const ProductExperienceSectionWrapper = styled("div")(({ theme }) => ({
    backgroundColor: alpha(theme.palette.primary.main, 0.15),
    marginLeft: `calc(${MainColumnVariableMargin.reference} * -1)`,
    marginRight: `calc(${MainColumnVariableMargin.reference} * -1)`,
    paddingLeft: MainColumnVariableMargin.reference,
    paddingRight: MainColumnVariableMargin.reference,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        marginLeft: 0,
        paddingLeft: theme.spacing(5),
    },
}));

function shiftArrayByOne<T>([first, ...rest]: ReadonlyArray<T>): T[] {
    return [...rest, first].filter(Boolean);
}
